import React from "react";
import {
    UserBacklogs,
    RangeInputSelectedValue,
} from "../../../../containers/RegistrationLoginPage/types";
import RangeInput from "../../../RangeInput";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
    numberValidation,
    regNumberValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface BacklogsInterface {
    configuration: UserBacklogs;
}

const Backlogs: React.FC<BacklogsInterface> = ({configuration}: BacklogsInterface) => {
    const {editable, values, selectedValue, fieldName} = configuration;

    const tooltipLabel =
        "If you had backlogs in 2 subjects, 1 of which you cleared in 2 attempts & the other in 3 attempts, then the total number of backlogs would be counted as (2+3=5).";

    return (
        <Field<RangeInputSelectedValue>
            name={fieldName}
            validate={composeValidators(
                regRequiredValidate("Please move slider to select backlogs"),
                regNumberValidate("Invalid backlogs"),
                numberValidation(values?.min, values?.max, values?.step),
            )}
            initialValue={selectedValue}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <RangeInput
                        heading="Number of Backlogs"
                        toolTip={tooltipLabel}
                        fieldName={fieldName}
                        editable={editable}
                        values={values}
                        isFocused={props.meta.active}
                        isTouched={props.meta.touched}
                        isError={errorHandler(props?.meta)}
                        initialValue={props.input.value}
                        inputRFF={props.input}
                    />
                );
            }}
        </Field>
    );
};

export default Backlogs;
